/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSyncEntitiesByTargetRequest} from '@cash-web/protos/squareup/cash/clientsync/app.pb'
import {GetSyncEntitiesByTargetResponse} from '@cash-web/protos/squareup/cash/clientsync/app.pb'


export const getSyncEntitiesByTarget = (request: GetSyncEntitiesByTargetRequest, options?: CashRequestOptions) => post<GetSyncEntitiesByTargetRequest, GetSyncEntitiesByTargetResponse>("/cash-app/sync-entities/v1.0/get-by-target", request, {...options, rejectOnError: true })